/**
 * @param {object} data stock json data
 * @returns {string} html string
 */
export const getPriceDevelopmentIndicator = data => {
  const hasPrices = data.latest_price && data.next_to_last_price;

  if (hasPrices) {
    const latestPrice = parseFloat(data.latest_price);
    const nextToLatestPrice = parseFloat(data.next_to_last_price);

    if (latestPrice > nextToLatestPrice) {
      return `<i class="fas fa-arrow-circle-up success"></i>`;
    } else if (latestPrice < nextToLatestPrice) {
      return `<i class="fas fa-arrow-circle-down alert"></i>`;
    } else {
      return `<i class="fas fa-arrow-circle-right"></i>`;
    }
  } else {
    return `<i class="fas fa-arrow-circle-right"></i>`;
  }
}